__turbopack_context__.v({
  "cc_logo": "styles-module-scss-module__CLkXOW__cc_logo",
  "contact": "styles-module-scss-module__CLkXOW__contact",
  "contact_content": "styles-module-scss-module__CLkXOW__contact_content",
  "contact_link": "styles-module-scss-module__CLkXOW__contact_link",
  "container": "styles-module-scss-module__CLkXOW__container",
  "header": "styles-module-scss-module__CLkXOW__header",
  "inner": "styles-module-scss-module__CLkXOW__inner",
  "phone_number": "styles-module-scss-module__CLkXOW__phone_number",
  "question": "styles-module-scss-module__CLkXOW__question",
  "text": "styles-module-scss-module__CLkXOW__text",
  "tour_btn": "styles-module-scss-module__CLkXOW__tour_btn",
});
